import { useState } from 'react';
import styles from './SolverProfilePicker.module.css';
import HilfeLink from './HilfeLink';
import { SOLVER_PROFILES, PROFILE_ORDER, profilesMatch } from '../utils/solverProfiles';
import type { SolverProfileId } from '../utils/solverProfiles';

interface SolverProfilePickerProps {
  /** Nur noch der kompakte Umschalter; der frühere „panel“-Modus nach der ersten Berechnung entfiel mit UX-Phase 1.2. */
  mode?: 'toggle';
  selectedProfile: SolverProfileId;
  onProfileChange: (id: SolverProfileId) => void;
  advancedWeights?: Record<string, unknown> | null;
}

/**
 * Kompakter Planungsschwerpunkt-Umschalter in der Werkzeugleiste des Stundenplan-Editors.
 * Die Lieblingszeiten-Intensität sitzt daneben als eigenes Auswahlfeld (App.tsx).
 */
export default function SolverProfilePicker({
  selectedProfile,
  onProfileChange,
  advancedWeights,
}: SolverProfilePickerProps) {
  const [isOpen, setIsOpen] = useState(false);

  const isCustom = !profilesMatch(advancedWeights, selectedProfile);
  const currentProfile = SOLVER_PROFILES[selectedProfile];

  return (
    <div className={styles.toggleContainer}>
      <button
        className={`${styles.toggleButton} ${isOpen ? styles.open : ''}`}
        onClick={() => setIsOpen(v => !v)}
        title="Planungsschwerpunkt wählen"
        aria-expanded={isOpen}
      >
        <span className={styles.togglePrefix}>Schwerpunkt:</span>
        <span className={styles.toggleLabel}>
          {isCustom ? '(angepasst)' : currentProfile.label}
        </span>
        <span className={styles.toggleChevron}>{isOpen ? '▴' : '▾'}</span>
      </button>
      <HilfeLink artikel="berechnung-feinjustieren#profile" titel="Hilfe zu den Berechnungsprofilen" />

      {isOpen && (
        <div className={styles.toggleDropdown}>
          {PROFILE_ORDER.map(id => (
            <button
              key={id}
              className={`${styles.dropdownCard} ${selectedProfile === id && !isCustom ? styles.dropdownCardSelected : ''}`}
              onClick={() => {
                onProfileChange(id);
                setIsOpen(false);
              }}
            >
              <span className={styles.dropdownCardLabel}>{SOLVER_PROFILES[id].label}</span>
              <span className={styles.dropdownCardDesc}>{SOLVER_PROFILES[id].shortDesc}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
